import { render, staticRenderFns } from "./SubRoot.vue?vue&type=template&id=0846d8df&"
import script from "./SubRoot.vue?vue&type=script&lang=js&"
export * from "./SubRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports